<template>
    <div class="add-visit" v-wechat-title="title">
        <van-cell-group style="margin-bottom: 10px;" class="group2" inset>
            <van-cell :value="provinceName" class="inputone" title="省份" required is-link  @click="showProvince = true">
                <template>
                    <div :style="{'color':provinceName=='请选择'?'#969799':'black'}">{{provinceName}}</div>
                </template>
            </van-cell>
            <van-popup  v-model="showProvince" round  position="bottom">
                <van-picker show-toolbar :columns="provinceArr" @cancel="showProvince = false" @confirm="confirmProvince" />
            </van-popup>

            <van-cell :value="cityName" class="inputone" title="城市" required is-link  @click="openCity">
                <template>
                    <div :style="{'color':cityName=='请选择'?'#969799':'black'}">{{cityName}}</div>
                </template>
            </van-cell>
            <van-popup v-model="showCity" round  position="bottom">
                <van-picker show-toolbar :columns="cityArr" @cancel="showCity = false" @confirm="confirmCity" />
            </van-popup>

            <van-cell :value="hospitalName" class="inputone" title="医院名称" required is-link  @click="openHospital">
                <template>
                    <div :style="{'color':hospitalName=='请选择'?'#969799':'black'}">{{hospitalName}}</div>
                </template>
            </van-cell>
            <van-popup v-model="showHospital" round  position="bottom">
                <van-picker show-toolbar :columns="hospitalArr" @cancel="showHospital = false" @confirm="confirmHospital" />
            </van-popup>

            <van-field v-model="doctorName" required label="医生姓名" placeholder="医生姓名" input-align="right"  label-class="black-label"/>
            
            <van-cell :value="visitTimeStr" class="inputone" title="拜访日期" required is-link  @click="showDatePicker=true">
            <template>
                <div :style="{'color':visitTimeStr=='请选择'?'#969799':'black'}">{{visitTimeStr}}</div>
                </template>
            </van-cell>
            <van-popup v-model="showDatePicker" round position="bottom">
                <van-datetime-picker v-model="visitDate" type="date" title="" :min-date="minDate" :max-date="maxDate" @confirm="confirmvisitDate" @cancel="showDatePicker=false"/>
            </van-popup>

            <van-cell :value="visitMode" class="inputone" title="拜访方式" is-link  @click="showvisitMode=true">
                <template>
                    <div :style="{'color':visitMode=='请选择'?'#969799':'black'}">{{visitMode}}</div>
                </template>
            </van-cell>
            <van-popup v-model="showvisitMode" round  position="bottom">
                <van-picker show-toolbar :columns="visitModeArr" @cancel="showvisitMode = false" @confirm="confirmvisitMode" />
            </van-popup>

            <van-cell :value="visitTarget" class="inputone" title="拜访目标" required is-link  @click="showvisitTarget=true">
                <template>
                    <div :style="{'color':visitTarget=='请选择'?'#969799':'black'}">{{visitTarget}}</div>
                </template>
            </van-cell>      
            <van-popup v-model="showvisitTarget" round  position="bottom">
                <van-picker show-toolbar :columns="visitTargetArr" @cancel="showvisitTarget = false" @confirm="confirmvisitTarget" />
            </van-popup>      

            <van-field v-model="visitResult" label="拜访结果" placeholder="拜访结果" input-align="right"  label-class="black-label"/>

        </van-cell-group>

        <div class="checkin-btn">
            <van-button @click="next()"  type="info" round block color="#0AA8AF">确认提交</van-button>
        </div>
	</div>
</template>
<script>
import Vue from 'vue';
import { GetHospital} from "@/api/api";
import { 
    getVolunteerProvinceCity,
    getConsultServiceOptions,
    getVisitTaskOptions,
    createDoctorVist,
} from '@/api/publicWelfareStaff' 
import { mapState } from "vuex";
import { Toast, } from 'vant';

Vue.use(Toast);
export default {
	data(){
		return {
            //标题
            title:"新增医护拜访",
            //省份
            provinceName:'请选择',
            showProvince:false,
            provinceArr:[],
            //城市
            cityName: '请选择',
            showCity: false,
            cityArr: [],
            // 医院名称
            hospitalName: '请选择',
            showHospital: false,
            hospitalArr: [],
            //医生姓名
            doctorName:'',
            //拜访日期
            showvisitDate:false,
            visitTimeStr: '请选择',
            visitDate:new Date(),
            showDatePicker:false,
            minDate: new Date(1949, 10, 1),
            maxDate: new Date(),
            //拜访方式
            visitMode:'请选择',
            showvisitMode:false,
            visitModeArr:[],
            //拜访目标
            visitTarget:'请选择',
            showvisitTarget:false,
            visitTargetArr:[],
            //拜访结果
            visitResult:'',

            provinceCity:{},//省份城市数据
		}
	},
	async created() {
        Toast.loading({
            duration: 0, // 持续展示 toast
            overlay: true,
            forbidClick: true
        });
        await this.getData()
        Toast.clear();
	},
    mounted(){
        // this.getData()
    },
    computed:{
        ...mapState(['publicWelfareStaff']),
    },
	methods:{
        async getData(){
            //获取省份
            await getVolunteerProvinceCity({ 
                volunteer_id:this.publicWelfareStaff.checkin_info.papid
            }).then(res => {
                this.provinceArr = Object.keys(res.data)
                this.provinceCity=res.data
            })
            //获取拜访方式
            await getConsultServiceOptions().then(res => {
                console.log("获取拜访方式：",res.data)
                    this.visitModeArr=Object.keys(res.data)
            })
            // 获取拜访目标 
            await getVisitTaskOptions().then(res => {
                console.log("获取拜访目标：",res.data)
                    this.visitTargetArr=Object.keys(res.data)
            })
        },
        timeFormat(time) {
            let year = time.getFullYear();
            let month = time.getMonth() + 1;
            let day = time.getDate();
            return year + '-' + month + '-' + day;
        },
        confirmProvince(value){
            // 选中省份 
            this.provinceName=value
            this.cityName="请选择"
            this.hospitalName = "请选择"
            this.cityArr=[]
            this.hospitalArr =[]
            this.showProvince = false
            console.log("省份,省份城市数据:",this.provinceName,this.provinceCity)

            this.cityArr=this.provinceCity[this.provinceName]
        },
        openCity() {
            console.log("openCity")
            if (this.cityArr.length < 1) {
                Toast('请先选择“省份”')
                return
            }
            this.showCity = true
        },
        async confirmCity(value){         //城市
            this.cityName=value
            this.hospitalName = "请选择"
            this.hospitalArr =[]
            this.showCity = false

            Toast.loading({
                duration: 0, // 持续展示 toast
                overlay: true,
                forbidClick: true
            });
            let hres = await GetHospital({
              province: this.provinceName,
              city: this.cityName
            })
            console.log(hres.data)
            let hospitalArr=[]
            hres.data.forEach(ele=>{
                hospitalArr.push(ele.name)
            })
            this.hospitalArr = hospitalArr
            if (this.hospitalArr.length < 1) {
              this.hospitalArr.unshift( '该城市下暂无项目医院' )
            }
            Toast.clear();

        },
        openHospital() {
            if (this.hospitalArr.length < 1) {
                Toast('请先选择“城市”')
                return
            }
            this.showHospital = true
        },
        confirmHospital(value) {    //医院名称
            this.hospitalName = value
            this.showHospital = false
        },
        confirmvisitTarget(value){  //拜访目标
            this.visitTarget=value
            this.showvisitTarget = false
        },
        confirmvisitMode(value){    //拜访方式
            this.visitMode=value
            this.showvisitMode = false
        },
        confirmvisitDate(value){   //拜访日期
            console.log("咨询时间",value)
            this.visitTimeStr=this.timeFormat(value)
            this.showDatePicker=false;
        },
		toastText(text){
			Toast(text)
		},
		async next(){
            console.log("publicWelfareStaff.originRoute:",this.publicWelfareStaff.originRoute)
            if(this.provinceName=="请选择"){
                Toast("省份不得为空!")
                return
            }
            if(this.cityName=="请选择"){
                Toast("城市不得为空!")
                return
            }
            if(this.hospitalName=="请选择"){
                Toast("医院名称不得为空!")
                return
            }
            if(!this.doctorName){
                Toast("医生姓名不得为空!")
                return
            }
            if(this.visitTimeStr=="请选择"){
                Toast("拜访日期不得为空!")
                return
            }
            if(this.visitTarget=="请选择"){
                Toast("拜访目标不得为空!")
                return
            }
            let now=new Date()
            let created=this.timeFormat(now)
            let sendData={
                province:this.provinceName,
                city:this.cityName,
                hospital_name:this.hospitalName,
                doctor_name:this.doctorName,
                vist_date:this.visitTimeStr,
                vist_mode:this.visitMode,
                vist_task:this.visitTarget,
                vist_result:this.visitResult,
                created:created,

                volunteer_id:this.publicWelfareStaff.checkin_info.papid,
            }
            console.log("sendData-createDoctorVist",sendData)
            await createDoctorVist(sendData).then(res => {
                if(res.data){
                    Toast.success('新增成功');
                    this.$router.replace({
                        name: "staffMsg",
                        query:{
                            title:'提交成功',
                            btnText:'返回医护拜访页',
                            statusText:'新增医护拜访成功',
                            notice:'',
                            // route:this.publicWelfareStaff.originRoute
                        }
                    })
                }
            }).catch((err) => {

            })

		},

	}
};
</script>

<style lang="less" scoped>
.add-visit {
	font-size: 16px;
    min-height: 100vh;
    background-color: #f9f9f9;
    padding-top: 15px;
    .group2{
        box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.1);
        .van-cell__value{
            flex:1.5 0 !important;
        }
        
    }
	.checkin-btn {
      margin: 25px;
    }
    /deep/ .noborder.van-cell::after{
      border-bottom:none !important;
    }



    ::v-deep .black-label{
        span{
            color:#323233;
        }
    }
    ::v-deep .grey-label{
        color:#9D9D9D;
        white-space:nowrap;
    }
}
</style>